import React, { useContext, useEffect } from "react";
import { ChangeEvent, useState } from "react";
import { Box, Paper, Stack, TextField, Typography } from "@mui/material";
import { TableContainer, TablePagination } from "@mui/material";
import { TableFooter, TableHead } from "@mui/material";
import { TableBody, TableCell, TableRow } from "@mui/material";
import { CustomTextField } from "../../../Styles/theme/customThemeprovider";
import { CustomSelect } from "../../../Styles/theme/customThemeprovider";
import { CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import BasicPopover from "../../../Components/Popover";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableCell } from "../../../Styles/tabelCellStyled/customTableCell";
import { StyledTableHead } from "../../../Styles/tabelCellStyled/customTableCell";
import TablePaginationActions from "../../../Components/Pagination/pagination";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { RegistoAtividadesExtra } from "./extraAtividades";
import { IPage5B, IPage5B_Two } from "../../../Interfaces/cadernos/caderno5/interfaces5B";
import { fertilizacao } from "../../../informacao_estatica";
import { desformatarNumero, desformatarNumero_return_null, formatarNumero_ao_digitar } from "../../../Func_genericas/formatar_numero_formato_pt";

import LoadingVulpes from "../../../Styles/Loader/loading";
import { formatar_numeros_Atividades_5B } from "../../../Componentes_modulo/FuncoesFormatarNumeroPT/cadernos/caderno5B";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { mensagem_tem_a_certeza_de_apagar_alteracoes, message_apenas_numero } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";


interface IRegistoAtividadesProps {
  idCabecalho: number;
  setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
  setRowsAtividades: React.Dispatch<React.SetStateAction<IPage5B[]>>;
  rowsAtividades: IPage5B[];
  setRowsAtividades_filtrada: React.Dispatch<React.SetStateAction<IPage5B[]>>;
  rowsAtividades_filtrada: IPage5B[];
}

export const RegistoAtividades: React.FC<IRegistoAtividadesProps> = ({
  idCabecalho,
  setOpenSnackSuccess,
  setOpenSnackError,
  setMessage,
  setRowsAtividades,
  rowsAtividades,
  setRowsAtividades_filtrada,
  rowsAtividades_filtrada
}) => {



  // Estado para a tabela Actividades
  const [atividades, setAtividades] = useState<IPage5B | undefined>();

  const auth = useContext(AuthContext);
  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [showNewRow, setShowNewRow] = useState<boolean>(false);
  const [openDeleteAtividades, setOpenDeleteAtividades] = React.useState<boolean>(false);

  const [page, setPage] = React.useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(5);

  const [error_data, set_error_data] = useState<boolean>(false);
  const [error_fertilizacao, set_error_fertilizacao] = useState<boolean>(false);
  const [error_t, set_error_t] = useState<boolean>(false);
  const [error_n, set_error_n] = useState<boolean>(false);
  const [error_po, set_error_po] = useState<boolean>(false);
  const [error_ko, set_error_ko] = useState<boolean>(false);
  const [error_mgo, set_error_mgo] = useState<boolean>(false);
  const [error_cao, set_error_cao] = useState<boolean>(false);
  const [error_so, set_error_so] = useState<boolean>(false);
  const [error_b, set_error_b] = useState<boolean>(false);
  const camposNumericos = ["t", "n", "po", "ko", "mgo", "cao", "so", "b"];

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    set_error_data(false)
    set_error_fertilizacao(false)
    set_error_t(false)
    set_error_n(false)
    set_error_po(false)
    set_error_ko(false)
    set_error_mgo(false)
    set_error_cao(false)
    set_error_so(false)
    set_error_b(false)

    handleCancel()

    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };


  const getActividades = async () => {
    try {
      let res = await get(auth.token.cookie_token, `/get_reg_actividades_5b_cabecalho/${idCabecalho}`);
      if (res.status === 200) {

        const formattedData = res.data.result.map(formatar_numeros_Atividades_5B);
        setRowsAtividades(formattedData);
        setRowsAtividades_filtrada(formattedData);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getActividades", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await getActividades();
    })();
  }, [idCabecalho]);


  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    const isCampoNumerico = camposNumericos.includes(name);
    set_flag_editado(true)

    if (name === "data") {
      if (value === undefined || value === "") {
        set_error_data(true);
      } else {
        set_error_data(false);
      }
      setAtividades((prevRegisto: any) => ({
        ...prevRegisto,
        [name]: value,
      }));
    } else if (name === "fertilizacao") {
      if (value === undefined) {
        set_error_fertilizacao(true);
      } else {
        set_error_fertilizacao(false);
      }
      setAtividades((prevRegisto: any) => ({
        ...prevRegisto,
        [name]: value,
      }));
    } else if (isCampoNumerico) {
      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      const valorNumerico = parseFloat(value.replace(",", "."));

      if (!isNaN(valorNumerico)) {
        if (name === "t") {
          set_error_t(false);
        } else if (name === "n") {
          set_error_n(false);
        } else if (name === "po") {
          set_error_po(false)
        } else if (name === "ko") {
          set_error_ko(false);
        } else if (name === "mgo") {
          set_error_mgo(false);
        } else if (name === "cao") {
          set_error_cao(false);
        } else if (name === "so") {
          set_error_so(false);
        } else if (name === "b") {
          set_error_b(false);
        }
      } else {
        if (name === "t") {
          set_error_t(true);
        } else if (name === "n") {
          set_error_n(true);
        } else if (name === "po") {
          set_error_po(true)
        } else if (name === "ko") {
          set_error_ko(true);
        } else if (name === "mgo") {
          set_error_mgo(true);
        } else if (name === "cao") {
          set_error_cao(true);
        } else if (name === "so") {
          set_error_so(true);
        } else if (name === "b") {
          set_error_b(true);
        }
      }
      setAtividades((prevNewRows: any) => ({
        ...prevNewRows,
        [name]: formatarNumero_ao_digitar(valorSemFormatar)
      }));
    } else {
      setAtividades((prevRegisto: any) => ({
        ...prevRegisto,
        [name]: value,
      }));
    }
  };

  const handleSaveNewAtividades = async () => {
    if (atividades?.data === undefined || atividades?.data === "" ||
      atividades.fertilizacao === undefined || atividades.fertilizacao === ""
    ) {
      if (atividades?.data === undefined || atividades?.data === "") {
        set_error_data(true);
      }
      if (atividades?.fertilizacao === undefined) {
        set_error_fertilizacao(true);
      }

      setMessage("Preencha os campos obrigatórios");
      setOpenSnackError(true);
    } else if (atividades === undefined) {
      setMessage("Preencha a tabela antes de gravar");
      setOpenSnackError(true);
    } else try {
      setIsLoading(true);
      let res = await post(auth.token.cookie_token, "new_reg_actividades_5b", {
        payload: {
          id_atividade: 0,
          data: atividades?.data === undefined ? "" : atividades.data,
          operacao_cult: atividades?.operacao_cult === undefined ? "" : atividades.operacao_cult,
          fertilizacao: atividades?.fertilizacao === undefined ? "" : atividades.fertilizacao,
          produto_utilizado: atividades?.produto_utilizado === undefined ? "" : atividades.produto_utilizado,
          t: atividades?.t === undefined ? null : desformatarNumero(atividades.t),
          n: atividades?.n === undefined ? null : desformatarNumero(atividades.n),
          po: atividades?.po === undefined ? null : desformatarNumero(atividades.po),
          ko: atividades?.ko === undefined ? null : desformatarNumero(atividades.ko),
          mgo: atividades?.mgo === undefined ? null : desformatarNumero(atividades.mgo),
          cao: atividades?.cao === undefined ? null : desformatarNumero(atividades.cao),
          so: atividades?.so === undefined ? null : desformatarNumero(atividades.so),
          b: atividades?.b === undefined ? null : desformatarNumero(atividades.b),
          campp_opcao: atividades?.campp_opcao === undefined ? "" : atividades.campp_opcao,
          id_registo_activi: idCabecalho,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        }
      });
      if (res.status === 200) {
        setMessage("Gravado com sucesso!");

        setAtividades(undefined);
        setRowsAtividades((prevRows) => {
          return [...prevRows, formatar_numeros_Atividades_5B(res.data.result)];
        });
        setRowsAtividades_filtrada((prevRows) => {
          return [...prevRows, formatar_numeros_Atividades_5B(res.data.result)];
        });
        setOpenSnackSuccess(true);
        setShowNewRow(false);
        set_flag_editado(false)
        set_error_data(false)
        set_error_fertilizacao(false)
        set_error_t(false)
        set_error_n(false)
        set_error_po(false)
        set_error_ko(false)
        set_error_mgo(false)
        set_error_cao(false)
        set_error_so(false)
        set_error_b(false)
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error: any) {
      func_print("handleSaveNewAtividades", error, true);
      // if (error?.status === 409) {

      //   setMessage(error?.response.data.detail);
      //   setOpenSnackError(true);
      // } else {
      //   setMessage("Erro ao efetuar a sua operação!");
      //   setOpenSnackError(true);
      // }
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
      }
      setOpenSnackError(true);

      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setShowNewRow(false);
    setAtividades(undefined);

  }

  // EDITAR
  const handleEdit = (obj: IPage5B) => {
    setAtividades(obj);
  };
  const onInputChange_editar = (event: any) => {
    const { name, value } = event.target;
    const isCampoNumerico = camposNumericos.includes(name);
    set_flag_editado(true)

    if (name === "data") {
      if (value === undefined || value === "") {
        set_error_data(true);
      } else {
        set_error_data(false);
      }
      setAtividades((prevRegisto: any) => ({
        ...prevRegisto,
        [name]: value,
      }));
    } else if (name === "fertilizacao") {
      if (value === undefined) {
        set_error_fertilizacao(true);
      } else {
        set_error_fertilizacao(false);
      }
      setAtividades((prevRegisto: any) => ({
        ...prevRegisto,
        [name]: value,
      }));
    } else if (isCampoNumerico) {
      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      const valorNumerico = parseFloat(valorSemFormatar.replace(",", "."));

      if (!isNaN(valorNumerico)) {
        if (name === "t") {
          set_error_t(false);
        } else if (name === "n") {
          set_error_n(false);
        } else if (name === "po") {
          set_error_po(false)
        } else if (name === "ko") {
          set_error_ko(false);
        } else if (name === "mgo") {
          set_error_mgo(false);
        } else if (name === "cao") {
          set_error_cao(false);
        } else if (name === "so") {
          set_error_so(false);
        } else if (name === "b") {
          set_error_b(false);
        }
      } else {
        if (name === "t") {
          set_error_t(true);
        } else if (name === "n") {
          set_error_n(true);
        } else if (name === "po") {
          set_error_po(true)
        } else if (name === "ko") {
          set_error_ko(true);
        } else if (name === "mgo") {
          set_error_mgo(true);
        } else if (name === "cao") {
          set_error_cao(true);
        } else if (name === "so") {
          set_error_so(true);
        } else if (name === "b") {
          set_error_b(true);
        }
      }
      setAtividades((prevExtraRow: any) => ({
        ...prevExtraRow,
        [name]: formatarNumero_ao_digitar(valorSemFormatar)
      }));
    } else {
      setAtividades((prevExtraRow: any) => ({
        ...prevExtraRow,
        [name]: value,
      }));
    }

  };
  const handleUpdateAtividades = async () => {


    if (atividades?.data === undefined || atividades?.data === "" ||
      atividades.fertilizacao === undefined || atividades.fertilizacao === ""
    ) {
      if (atividades?.data === undefined || atividades?.data === "") {
        set_error_data(true);
      }
      if (atividades?.fertilizacao === undefined) {
        set_error_fertilizacao(true);
      }

      setMessage("Preencha os campos obrigatórios");
      setOpenSnackError(true);
    } else {

      try {
        setIsLoading(true);

        const res = await post(auth.token.cookie_token, `update_reg_actividades_5b`, {
          payload: {
            id_atividade: atividades.id_atividade,
            data: atividades?.data === undefined ? null : atividades.data,
            operacao_cult: atividades?.operacao_cult === undefined ? null : atividades.operacao_cult,
            fertilizacao: atividades?.fertilizacao === undefined ? null : atividades.fertilizacao,
            produto_utilizado: atividades?.produto_utilizado === undefined ? null : atividades.produto_utilizado,
            t: atividades?.t === undefined ? null : desformatarNumero_return_null(atividades.t),
            n: atividades?.n === undefined ? null : desformatarNumero_return_null(atividades.n),
            po: atividades?.po === undefined ? null : desformatarNumero_return_null(atividades.po),
            ko: atividades?.ko === undefined ? null : desformatarNumero_return_null(atividades.ko),
            mgo: atividades?.mgo === undefined ? null : desformatarNumero_return_null(atividades.mgo),
            cao: atividades?.cao === undefined ? null : desformatarNumero_return_null(atividades.cao),
            so: atividades?.so === undefined ? null : desformatarNumero_return_null(atividades.so),
            b: atividades?.b === undefined ? null : desformatarNumero_return_null(atividades.b),
            campp_opcao: atividades?.campp_opcao === undefined ? null : atividades.campp_opcao,
            id_registo_activi: atividades.id_registo_activi,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });
        if (res.status === 200) {
          setMessage("Registado com sucesso!");
          const updatedRows = rowsAtividades.map((row) => {
            if (row.id_atividade === atividades.id_atividade) {
              return formatar_numeros_Atividades_5B(res.data.result)
            } else {
              return { ...row }
            }
          });
          set_flag_editado(false)
          set_error_data(false)
          set_error_fertilizacao(false)
          set_error_t(false)
          set_error_n(false)
          set_error_po(false)
          set_error_ko(false)
          set_error_mgo(false)
          set_error_cao(false)
          set_error_so(false)
          set_error_b(false)
          setRowsAtividades(updatedRows !== undefined ? updatedRows : []);
          setRowsAtividades_filtrada(updatedRows !== undefined ? updatedRows : []);
          setAtividades(undefined);
          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error: any) {
        func_print("handleSaveAtividades", error, true);
        if (error?.status === 409) {

          setMessage(error?.response.data.detail);
          setOpenSnackError(true);
        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }

        setIsLoading(false);
      }
    }
  };

  // Delete
  const handleClickOpenDeleteAtividades = (obj: IPage5B) => {
    setAtividades(obj)
    setOpenDeleteAtividades(true);
  };
  const handleDeleteAtividades = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete__reg_actividades_5b/${atividades?.id_atividade}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        setOpenDeleteAtividades(false);
        setAtividades(undefined);
        setRowsAtividades((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_atividade !== atividades?.id_atividade),
        ]);
        setRowsAtividades_filtrada((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_atividade !== atividades?.id_atividade),
        ]);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDeleteAnalise", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };


  /**************** PAGINAÇÃO *********************/
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rowsAtividades_filtrada.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <CustomThemeProvider>
      {isLoading ? (
        <LoadingVulpes />
      ) : (
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{ height: "auto", width: "auto", margin: 2, padding: 2, }}
        >
          <table style={{ width: "100%" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={12}
                  sx={{
                    fontWeight: 600,
                    textAlign: "left",
                    fontFamily: "candara",
                    fontSize: 18,
                  }}
                >
                  Registo das atividades
                </TableCell>

                <TableCell colSpan={2}>
                  {is_historico === true ? <></> :

                    <BarraDeFerramentas
                      mostrarBotaoNovo
                      textoBotaoNovo="Novo Registo"
                      aoClicarNovo={() => setShowNewRow(true)}
                    />}
                </TableCell>
              </TableRow>
              <TableRow>
                <StyledTableHead rowSpan={2}>
                  <Stack direction="row" justifyContent="center">
                    Data*
                    <Box margin={-1} padding={0}>
                      <BasicPopover
                        text={"Formato para registo diário deverá ser: dd-mm-aaaa"}
                      />
                    </Box>
                  </Stack>
                </StyledTableHead>
                <StyledTableHead rowSpan={2} sx={{ minWidth: 180 }}>
                  <Stack direction="row" justifyContent="center">
                    Operação Cultural
                    <Box margin={-1} padding={0}>
                      <BasicPopover
                        text={"Registar qualquer intervenção na cultura, incluindo no solo, exceto a fertilização.\n\n Preenchimento opcional para as intervenções Conservação do Solo - Sementeira Direta,\n Conservação do Solo - Enrelvamento» e «Apoio Zonal Peneda-Gerês - manutenção de socalcos»."}
                      />
                    </Box>
                  </Stack>
                </StyledTableHead>
                <StyledTableHead rowSpan={2} sx={{ minWidth: 180 }}>
                  <Stack direction="row" justifyContent="center">
                    Fertilização*
                    <Box margin={-1} padding={0}>
                      <BasicPopover
                        text={" O beneficiário deverá preencher com um dos seguintes valores por linha (data da aplicação): \nAplicação de corretivos\nFertilização fundo\nAdubação verde\nAplicação de estrume\nAplicação de chorume\nFertilização cobertura\n\nPreenchimento obrigatório para todas as tipologias da intervenção «Planos Zonais Agroambientais»."}
                      />
                    </Box>
                  </Stack>
                </StyledTableHead>
                <StyledTableHead rowSpan={2} sx={{ minWidth: 180 }}>
                  Produto Utilizado
                </StyledTableHead>
                <StyledTableHead>Quantidade Aplicada</StyledTableHead>
                <StyledTableHead colSpan={8}>
                  Incorporação de nutrientes (Kg)
                </StyledTableHead>

                <StyledTableHead rowSpan={2}>Ações</StyledTableHead>
              </TableRow>
              <TableRow>
                <StyledTableHead>t</StyledTableHead>
                <StyledTableHead>N</StyledTableHead>
                <StyledTableHead>P2O5</StyledTableHead>
                <StyledTableHead>K2O</StyledTableHead>
                <StyledTableHead>MgO</StyledTableHead>
                <StyledTableHead>CaO</StyledTableHead>
                <StyledTableHead>SO3</StyledTableHead>
                <StyledTableHead>B</StyledTableHead>
                <StyledTableHead sx={{ minWidth: 150 }}>Outros<BasicPopover text={"Identificar o nutriente aplicado, quando este não esteja representado no registo"} /></StyledTableHead>
              </TableRow>
            </TableHead>

            {showNewRow && (
              <TableBody>
                <TableRow>
                  <StyledTableCell>
                    <TextField
                      variant="filled"
                      name="data"
                      type="date"

                      value={atividades?.data !== undefined ? atividades?.data : ""}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        onInputChange(e)
                      }
                    />
                    {error_data && (
                      <p style={{ color: "#c90606", fontSize: "11px" }}>
                        Preencha este campo
                      </p>
                    )}
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="operacao_cult"
                      value={atividades?.operacao_cult}
                      onChange={onInputChange}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomSelect
                      value={atividades?.fertilizacao !== undefined ? atividades?.fertilizacao : ""}
                      name="fertilizacao"
                      onChange={onInputChange}
                      options={fertilizacao}
                      label="Fertilização"
                      minWidth={120}
                    />
                    {error_fertilizacao && (
                      <p style={{ color: "#c90606", fontSize: "11px" }}>
                        Preencha este campo
                      </p>
                    )}
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="produto_utilizado"
                      value={atividades?.produto_utilizado}
                      onChange={onInputChange}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="t"
                      value={atividades?.t}
                      onChange={onInputChange}
                      error={error_t}
                      helperText={error_t ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="n"
                      value={atividades?.n}
                      onChange={onInputChange}
                      error={error_n}
                      helperText={error_n ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="po"
                      value={atividades?.po}
                      onChange={onInputChange}
                      error={error_po}
                      helperText={error_po ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="ko"
                      value={atividades?.ko}
                      onChange={onInputChange}
                      error={error_ko}
                      helperText={error_ko ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="mgo"
                      value={atividades?.mgo}
                      onChange={onInputChange}
                      error={error_mgo}
                      helperText={error_mgo ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="cao"
                      value={atividades?.cao}
                      onChange={onInputChange}
                      error={error_cao}
                      helperText={error_cao ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="so"
                      value={atividades?.so}
                      onChange={onInputChange}
                      error={error_so}
                      helperText={error_so ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="b"
                      value={atividades?.b}
                      onChange={onInputChange}
                      error={error_b}
                      helperText={error_b ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="campp_opcao"
                      value={atividades?.campp_opcao}
                      onChange={onInputChange}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <Stack direction="row" justifyContent="center">
                      <ButtonCadernos
                        mostrarBotaoCancelar
                        aoClicarCancelar={() => {
                          if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                          } else {
                            handleCancel()
                          }
                        }}
                        mostrarBotaoGravar
                        aoClicarGravar={() => handleSaveNewAtividades()}
                      />
                    </Stack>
                  </StyledTableCell>
                </TableRow>
              </TableBody>
            )}

            {(rowsPerPage > 0
              ? rowsAtividades_filtrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : rowsAtividades_filtrada
            ).map((row, key) => (
              <TableBody key={key}>
                <TableRow >
                  {atividades?.id_atividade === row.id_atividade ? (
                    <>
                      <StyledTableCell>
                        <TextField
                          variant="filled"
                          name="data"
                          type="date"
                          value={atividades?.data !== undefined ? atividades?.data : ""}
                          onChange={onInputChange_editar}
                        />
                        {error_data && (
                          <p style={{ color: "#c90606", fontSize: "11px" }}>
                            Preencha este campo
                          </p>
                        )}
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="operacao_cult"
                          value={atividades.operacao_cult}
                          onChange={onInputChange_editar}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomSelect
                          value={atividades.fertilizacao !== undefined ? atividades.fertilizacao : ""}
                          name="fertilizacao"
                          onChange={onInputChange_editar}
                          options={fertilizacao}
                          label="Fertilização"
                          minWidth={120}
                        />
                        {error_fertilizacao && (
                          <p style={{ color: "#c90606", fontSize: "11px" }}>
                            Preencha este campo
                          </p>
                        )}
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="produto_utilizado"
                          value={atividades.produto_utilizado}
                          onChange={onInputChange_editar}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="t"
                          value={atividades.t}
                          onChange={onInputChange_editar}
                          error={error_t}
                          helperText={error_t ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="n"
                          value={atividades.n}
                          onChange={onInputChange_editar}
                          error={error_n}
                          helperText={error_n ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="po"
                          value={atividades.po}
                          onChange={onInputChange_editar}
                          error={error_po}
                          helperText={error_po ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="ko"
                          value={atividades.ko}
                          onChange={onInputChange_editar}
                          error={error_ko}
                          helperText={error_ko ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="mgo"
                          value={atividades.mgo}
                          onChange={onInputChange_editar}
                          error={error_mgo}
                          helperText={error_mgo ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="cao"
                          value={atividades.cao}
                          onChange={onInputChange_editar}
                          error={error_cao}
                          helperText={error_cao ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="so"
                          value={atividades.so}
                          onChange={onInputChange_editar}
                          error={error_so}
                          helperText={error_so ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="b"
                          value={atividades.b}
                          onChange={onInputChange_editar}
                          error={error_b}
                          helperText={error_b ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="campp_opcao"
                          value={atividades.campp_opcao}
                          onChange={onInputChange_editar}
                        />
                      </StyledTableCell>
                    </>
                  ) : (
                    <>
                      <StyledTableCell>{row.data} </StyledTableCell>
                      <StyledTableCell>{row.operacao_cult}</StyledTableCell>
                      <StyledTableCell>{row.fertilizacao}</StyledTableCell>
                      <StyledTableCell>{row.produto_utilizado}</StyledTableCell>
                      <StyledTableCell>{row.t} </StyledTableCell>
                      <StyledTableCell>{row.n} </StyledTableCell>
                      <StyledTableCell>{row.po} </StyledTableCell>
                      <StyledTableCell>{row.ko} </StyledTableCell>
                      <StyledTableCell>{row.mgo} </StyledTableCell>
                      <StyledTableCell>{row.cao} </StyledTableCell>
                      <StyledTableCell>{row.so} </StyledTableCell>
                      <StyledTableCell>{row.b} </StyledTableCell>
                      <StyledTableCell>{row.campp_opcao}</StyledTableCell>
                    </>
                  )}

                  {atividades?.id_atividade === row.id_atividade ? (
                    <StyledTableCell>
                      <ButtonCadernos
                        mostrarBotaoGravar
                        aoClicarGravar={() => handleUpdateAtividades()}
                        mostrarBotaoCancelar
                        aoClicarCancelar={() => {
                          if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                          } else {
                            handleCancel()
                          }
                        }}
                      />
                    </StyledTableCell>
                  ) : (
                    <StyledTableCell>
                      {is_historico === true ? <></> :

                        <ButtonCadernos
                          mostrarBotaoEditar
                          aoClicarEditar={() => handleEdit(row)}
                          mostrarBotaoApagar
                          aoClicarApagar={() => handleClickOpenDeleteAtividades(row)}
                        />}
                    </StyledTableCell>
                  )}
                </TableRow>
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={19} />
                  </TableRow>
                )}
              </TableBody>
            ))}

            <RegistoAtividadesExtra
              idCabecalho={idCabecalho}
              setOpenSnackSuccess={setOpenSnackSuccess}
              setOpenSnackError={setOpenSnackError}
              setMessage={setMessage}
            />

            <TableFooter>
              <TableRow sx={{ width: "100%" }}>
                <TableCell colSpan={7}>
                  <Typography style={{ fontSize: 14, fontFamily: "candara" }}>
                    * Campos de preenchimento obrigatório
                  </Typography>
                </TableCell>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "Todas", value: -1 }]}
                  colSpan={7}
                  count={rowsAtividades_filtrada.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  labelDisplayedRows={({ from, to, count }) => {
                    return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                  }}
                  labelRowsPerPage={'Linhas por página'}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </table>
          <ConfirmDialog
            open={openDeleteAtividades}
            onClose={() => setOpenDeleteAtividades(false)}
            onConfirm={handleDeleteAtividades}
            message="Deseja eliminar o registo?"
          />
          <ConfirmDialog
            open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
            onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
            onConfirm={() => handleCloseDialog()}
            message={mensagem_tem_a_certeza_de_apagar_alteracoes}
          />
        </TableContainer>
      )}
    </CustomThemeProvider>

  );
};
